/** How a failed RTK Query load is shown (FR-048): 403 is no-access, 404 not-found, anything else an error with Retry. */
export type QueryErrorKind = "no-access" | "not-found" | "error";

/** The screen state of a primary query: still loading, one of the error kinds, or ready to render. */
export type QueryState = "loading" | QueryErrorKind | "ready";

/** The parts of an RTK Query hook result that decide its screen state. */
export interface QueryStatus {
  isLoading: boolean;
  isError: boolean;
  error?: unknown;
}

/** Maps an RTK Query error (`FetchBaseQueryError`, `SerializedError` or anything else) to its kind. */
export const queryErrorKind = (error: unknown): QueryErrorKind => {
  const status =
    error && typeof error === "object"
      ? (error as { status?: unknown }).status
      : undefined;
  if (status === 403) return "no-access";
  if (status === 404) return "not-found";
  return "error";
};

/** The screen state of a query result. A failed load is never "ready", so it is never shown as empty. */
export const queryState = ({
  isLoading,
  isError,
  error,
}: QueryStatus): QueryState => {
  if (isLoading) return "loading";
  if (isError) return queryErrorKind(error);
  return "ready";
};
